import { Steps } from "src/types";

export const getNextVisibleStep = (steps: Steps[], fromScreenIndex: number): {step: Steps; screenIndex: number} | null => {
  if (!steps || !Array.isArray(steps)) return null;
  const visibleSorted = steps
    .filter((s) => s && !s.hidden && typeof s.screenIndex === 'number')
    .sort((a, b) => a.screenIndex - b.screenIndex);

  const next = visibleSorted.find((s) => s.screenIndex > fromScreenIndex);
  return next ? { step: next, screenIndex: next.screenIndex } : null;
};

export const getPreviousVisibleStep = (steps: Steps[], stepsHistory: number[], currentScreenIndex: number): {step: Steps; screenIndex: number} | null => {
  if (!steps || !Array.isArray(steps) || !stepsHistory || !Array.isArray(stepsHistory)) return null;

  const fromHistoryIndex = stepsHistory.lastIndexOf(currentScreenIndex);
  for (let i = fromHistoryIndex - 1; i >= 0; i--) {
    const candidateScreen = stepsHistory[i];
    const candidateStep = steps.find((s) => s.screenIndex === candidateScreen);
    if (candidateStep && !candidateStep.hidden) {
      return { step: candidateStep, screenIndex: candidateScreen };
    }
  }

  const visibleSteps = steps
    .filter((s) => s && !s.hidden && typeof s.screenIndex === 'number')
    .sort((a, b) => a.screenIndex - b.screenIndex);
  const currentIndex = visibleSteps.findIndex((s) => s.screenIndex === currentScreenIndex);
  if (currentIndex > 0) {
    const prev = visibleSteps[currentIndex - 1];
    return { step: prev, screenIndex: prev.screenIndex };
  }

  return null;
};
